module.exports = __webpack_public_path__ + "static/img/LxwlyqjcT.b5563718.png";